import { render, staticRenderFns } from "./PointTree.vue?vue&type=template&id=21b94522&scoped=true"
import script from "./PointTree.vue?vue&type=script&lang=js"
export * from "./PointTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b94522",
  null
  
)

export default component.exports